require('../../modules/es.typed-array.uint32-array');
require('./methods');
var global = require('../../internals/global');

module.exports = global.Uint32Array;
